import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useDeveloperInfo } from '../hooks/useApi';

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { data, isLoading, error } = useDeveloperInfo();

  if (isLoading || (data === undefined && !error)) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="40vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!data?.user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
